/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateLegalPayload } from '../model/createLegalPayload';
import { IdDataLong } from '../model/idDataLong';
import { LegalMotion } from '../model/legalMotion';
import { UpdateLegalPayload } from '../model/updateLegalPayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LegalNoticeService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create legal motion
     * 
     * @param payload Legal notice attributes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLegalNotice(payload?: CreateLegalPayload, observe?: 'body', reportProgress?: boolean): Observable<IdDataLong>;
    public createLegalNotice(payload?: CreateLegalPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IdDataLong>>;
    public createLegalNotice(payload?: CreateLegalPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IdDataLong>>;
    public createLegalNotice(payload?: CreateLegalPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IdDataLong>(`${this.basePath}/api/legals`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete legal motion by id
     * 
     * @param legalId Legal notice identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteLegalNotice(legalId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteLegalNotice(legalId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteLegalNotice(legalId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteLegalNotice(legalId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (legalId === null || legalId === undefined) {
            throw new Error('Required parameter legalId was null or undefined when calling deleteLegalNotice.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/legals/${encodeURIComponent(String(legalId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get legal motion by id
     * 
     * @param legalId Legal notice identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalNotices(legalId: number, observe?: 'body', reportProgress?: boolean): Observable<LegalMotion>;
    public getLegalNotices(legalId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LegalMotion>>;
    public getLegalNotices(legalId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LegalMotion>>;
    public getLegalNotices(legalId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (legalId === null || legalId === undefined) {
            throw new Error('Required parameter legalId was null or undefined when calling getLegalNotices.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<LegalMotion>(`${this.basePath}/api/legals/${encodeURIComponent(String(legalId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all legal motions
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListLegalNotices(observe?: 'body', reportProgress?: boolean): Observable<Array<LegalMotion>>;
    public getListLegalNotices(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LegalMotion>>>;
    public getListLegalNotices(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LegalMotion>>>;
    public getListLegalNotices(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<LegalMotion>>(`${this.basePath}/api/legals`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update legal motion by id
     * 
     * @param legalId Legal notice identifier
     * @param payload Legal notice attributes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLegalNotice(legalId: number, payload?: UpdateLegalPayload, observe?: 'body', reportProgress?: boolean): Observable<LegalMotion>;
    public updateLegalNotice(legalId: number, payload?: UpdateLegalPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LegalMotion>>;
    public updateLegalNotice(legalId: number, payload?: UpdateLegalPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LegalMotion>>;
    public updateLegalNotice(legalId: number, payload?: UpdateLegalPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (legalId === null || legalId === undefined) {
            throw new Error('Required parameter legalId was null or undefined when calling updateLegalNotice.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<LegalMotion>(`${this.basePath}/api/legals/${encodeURIComponent(String(legalId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
